import gql from 'graphql-tag'

export const fetchCompany = companyId => {
	return {
		query: gql`
			query ($companyId: bigint!) {
				company: companies_by_pk(id: $companyId) {
					address
					company_name
					image {
						id
						file_name
						url
						mime
					}
					registry_code
					legal_name
					phone
					email
					style
				}
			}
		`,
		variables: { companyId }
	}
}
